module.exports = __webpack_public_path__ + "static/img/cz-wdj.8ce4e84b.png";